import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import reportWebVitals from './reportWebVitals'

import Home from './pages/home'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import withRoot from './withRoot'

if (document.getElementById('root') as HTMLElement) {
  const urlParams = new URLSearchParams(document.location.search);

  const apiKey = urlParams?.get("apiKey")!;

  const config = {
    hideAppointmentButton: urlParams?.get('hideAppointmentButton'),
    hideAppBar: urlParams?.get('hideAppBar'),
    hideFooter: urlParams?.get('hideFooter'),
    hideProgressBar: urlParams?.get('hideProgressBar'),
    age: urlParams?.get('age'),
    isSmoker: urlParams?.get('isSmoker'),
    postcode: urlParams?.get('postcode'),
    employment: urlParams?.get('employment'),
    income: urlParams?.get('income'),
    requestType: urlParams?.get('requestType'),
    occupation: {
      code: urlParams?.get('occupation_code'),
      description: urlParams?.get('occupation_description'),
    },
    occupationCode: urlParams?.get('occupation_code'),
    occupationDescription: urlParams?.get('occupation_description'),
    isPartnerCovered:
      urlParams?.get('partner_covered') === 'Yes' ? 'true' : 'false',
    partnerAge: urlParams?.get('partner_age'),
    partnerEmployment: urlParams?.get('partner_employment'),
    partnerIncome: urlParams?.get('partner_income'),
    isPartnerSmoker:
      urlParams?.get('partner_smoker') === 'Yes' ? 'true' : 'false',
    partnerOccupation: {
      code: urlParams?.get('partner_occupation_code'),
      description: urlParams?.get('partner_occupation_description'),
    },
    partnerOccupationCode: urlParams?.get('partner_occupation_code'),
    partnerOccupationDescription: urlParams?.get('partner_occupation_description'),
  };

  const HomeWithRoot = withRoot(Home, apiKey, config);

  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path="/client" element={<HomeWithRoot />} />
          <Route path="/404" element={<div>Page Not Found!</div>} />
          <Route path="*" element={<Navigate replace to="/404" />} />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root'),
  )
}

const renderApp = (apiKey: string, config: any, element: HTMLElement) => {
  if (element) {
    const HomeWithRoot = withRoot(Home, apiKey, config);

    if (apiKey) {
      ReactDOM.render(
        <HomeWithRoot />,
        element,
      );
    }
  } else {
    throw new Error("Element does not exist.");
  }
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

//

export { renderApp }